import { Box, Button, Divider, Typography } from '@mui/material';
import useStore from '../../state-files/zustondStoreStates';
import AddDiscussionMember from '../../discussions/AddDiscussionMemberWidget';
import { useNavigate } from "react-router-dom";
import fetchDiscussions from '../../helper-methods/fetchDiscussions';
import UserListComponent from '../../discussions/UserListComponent';
import leaveDiscussion from '../../helper-methods/LeaveDiscussion';

const DesktopUserListComponent = ({ chatId, setDiscussions, sortedUsers, userList, chatAdmins, chatTitle }) => {
  const { greenButtonSX } = useStore();
  const navigate = useNavigate();
  const currentUserAdmin = chatAdmins?.includes(localStorage.getItem('userId'));

  return (
    <Box
      sx={{
        flexBasis: "20%",
        display: { xs: 'none', md: "flex" },
        flexDirection: "column", // Stack users vertically
        overflowY: "auto",
        height: '95vh',
        backgroundColor: "grey.200",
        borderLeft: "1px solid #e0e0e0" // Optional: visual divider
      }}
    >

      <Box sx={[greenButtonSX, { marginBottom: 1 }]}>
        <Button
          id="leaveDiscussionButton"
          variant="contained"
          color="none"
          onClick={async () => {
            const response = await leaveDiscussion(chatId);
            if (response === 200) {
              navigate('/discussions');
              fetchDiscussions(setDiscussions);
            }
          }}
          style={{ boxShadow: 'none' }}
        > Leave Discussion </Button>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', position: 'relative', pl: 1, pr: 1 }}>
        <Typography
          variant="h5"
          sx={{ mb: 1, fontWeight: 'medium', textAlign: 'center' }}
        >
          Users:
        </Typography>
        
        <AddDiscussionMember sx={{ display: currentUserAdmin ? '' : 'none' }}
          isBold={true}
          chatId={chatId}
        />

      </Box>
      <Divider sx={{ mb: 1, borderBottomWidth: 2, borderColor: 'rgba(0,0,0,0.12)' }} />
      {/* Map each username to a Typography component */}
      {
        sortedUsers.map((name, index) => {
          var userInformation = userList.find(u => u.name === name);
          const isChatAdmin = chatAdmins?.includes(name.id);
          return (
            <UserListComponent userInformation={userInformation} isChatAdmin={isChatAdmin} index={index} chatId={chatId} currentUserAdmin={currentUserAdmin} />
          )
        })}
    </Box>
  )
};

export default DesktopUserListComponent;